//desktop filter menu :
document.addEventListener("DOMContentLoaded", () => {
  const FILTER_KEY = "lastClickedMenuTitle";

  document
    .querySelectorAll(".link-main-header a")
    .forEach((link) =>
      link.addEventListener("click", () =>
        localStorage.setItem(FILTER_KEY, link.textContent.trim().toLowerCase())
      )
    );

  const matchTitle = localStorage.getItem(FILTER_KEY);
  document.querySelectorAll(".filter__menu > li").forEach((filterItem) => {
    const parentTitle = filterItem.dataset.title?.trim().toLowerCase();
    const childItems = filterItem.querySelectorAll(".child-menu li");
    let matched = false;

    filterItem.classList.remove("filter-menu__link--active");
    childItems.forEach((child) =>
      child.classList.remove("filter-menu__link--active")
    );

    if (parentTitle === matchTitle) {
      filterItem.classList.add("filter-menu__link--active");
      matched = true;
    }

    childItems.forEach((child) => {
      if (child.dataset.title?.trim().toLowerCase() === matchTitle) {
        child.classList.add("filter-menu__link--active");
        matched = true;
      }
    });

    filterItem.style.display = matched || !matchTitle ? "block" : "none";
  });
});

function copyDiscountCode(el) {
  const code = el.getAttribute("data-code");
  const successText = el.getAttribute('data-successtext') || 'Copied!';
  // const originalText = el.getAttribute('data-originaltext') || 'Copy Code';

  // Create a temporary input to copy text
  const tempInput = document.createElement("input");
  tempInput.value = code;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);

  // Update button text
  el.textContent = successText;

  // Revert text after 2 seconds
  // setTimeout(() => {
  //   el.textContent = originalText;
  // }, 2000);
}

document.addEventListener("DOMContentLoaded", () => {
  const closeBtn = document.querySelector("[closeTopBar]");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      const topBar = closeBtn.closest(".notification-bar");
      if (topBar) {
        topBar.style.display = "none";
      }
    });
  }
});

//mobile filter menu :

document.addEventListener("DOMContentLoaded", () => {
  const FILTER_KEY = "lastClickedMenuTitle";

  // 1. Save clicked menu title from both header and drawer
  document
    .querySelectorAll(".link-main-header a")
    .forEach((link) =>
      link.addEventListener("click", () =>
        localStorage.setItem(FILTER_KEY, link.textContent.trim().toLowerCase())
      )
    );

  const applyFilterMenuHighlight = (selector) => {
    const savedTitle = localStorage.getItem(FILTER_KEY);
    const items = document.querySelectorAll(selector);

    items.forEach((filterItem) => {
      const parentTitle = filterItem.dataset.title?.trim().toLowerCase();
      const childItems = filterItem.querySelectorAll("ul li");
      let matched = false;

      filterItem.classList.remove("filter-menu__link--active");
      childItems.forEach((child) =>
        child.classList.remove("filter-menu__link--active")
      );

      // Match parent title
      if (parentTitle === savedTitle) {
        filterItem.classList.add("filter-menu__link--active");
        matched = true;
      }

      // Match child title
      childItems.forEach((child) => {
        const childTitle = child.dataset.title?.trim().toLowerCase();
        if (childTitle === savedTitle) {
          child.classList.add("filter-menu__link--active");
          matched = true;
        }
      });

      // Show only matched
      filterItem.style.display = matched || !savedTitle ? "block" : "none";
    });
  };

  // 2. Apply to both desktop and mobile filter menus
  applyFilterMenuHighlight(".filter__menu > li");
  applyFilterMenuHighlight(".filter__menu-mobile > li");
});

// marken page scroll content

document.querySelectorAll(".tab-main-title a").forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();
    // Remove "active" class from all tab links
    document.querySelectorAll(".tab-main-title a").forEach((t) => {
      t.classList.remove("active");
    });

    // Add "active" class to the clicked link
    this.classList.add("active");

    //console.log("click !!!");
    const header = document.querySelector(".brand-tab");
    // console.log(header,'header')
    const headerHeight = header.offsetHeight;

    const targetElement = document.querySelector(this.getAttribute("href"));

    const targetPosition = targetElement.offsetTop - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  });
});

/****** Newsletter popup start ******/
document.addEventListener("click", function(event) {
  const popup = document.getElementById("newsletter-popup-form");
  const formBlock = popup.querySelector(".newsletter-form-block");

  // Open popup
  if (event.target.closest(".sticky-text")) {
    popup.style.display = "block";
    document.body.classList.add("newsletter-popup-open");
    return;
  }

  // Close popup if clicked outside form or on close button
  if (
    popup.style.display === "block" &&
    (!formBlock.contains(event.target) || event.target.closest(".close-newsletter-form"))
  ) {
    popup.style.display = "none";
    document.body.classList.remove("newsletter-popup-open");
  }
});


/****** Newsletter popup end ******/